import { useState, useEffect, useRef } from "react";
// import { useUserDetailContext } from "../../UserDetailContext";
import bg_image from "../../../Assets/img/Personal_bg_image.png";

import CryptoJS from 'crypto-js';
// import QRCode from "qrcode.react";
import {
  Dialog,
  Avatar,
  Tab,
  Tabs,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import _ from "lodash"; // For debouncing
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import GroupsIcon from "@mui/icons-material/Groups";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import { IoLinkSharp } from "react-icons/io5";
import PreviewFileItem from "../../Utilities/PreviewFileItem";
import { useProfileContext } from "../../ProfileDetailContext";
// import QrCodeProfile from "../MyProfileDetails/QrCodeProfile";
import { SkillItem } from "./PersonalProfileView";
import NotAvailable from "../../../Assets/img/img not available.png";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import {
  formatDate,
  formatTimeAmPm,
  sortListByDate,
} from "../../Utilities/ValidationFunctions";
import QrCodeProfile from "../MyProfileDetails/QrCodeProfile";
import { useMediaQuery } from "rsuite/esm/useMediaQuery/useMediaQuery";

const ProfessionalProfileView = ({
  professionalData,
  isFieldVisible,
  services,
  projectList,
  awardsList,
  educationList,
  certificateList,
  experienceList,
  resumeData,
  videoResume,
  connectionCount,
  link,
  recommendations,
}) => {
  const bgImage = bg_image;
  // const objectId = localStorage.getItem("objectId");
  // const SCROLL_MARGIN_OFFSET = 136;
  // const SCROLL_BUFFER = 200; // Buffer zone to determine active section
console.log("projectListprojectList", projectList)
  const isSmallLaptop = useMediaQuery("(max-width:1200px)");
  console.log("recommendationsrecommendations", recommendations);
  const { openDocumentViewer } = useProfileContext();
  const [openModal, setOpenModal] = useState(false);
  // const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const encryptedUrlRef = useRef(""); // Using a ref to persist encryptedUrl across renders without causing re-renders
  const qrCodeSize = isSmallLaptop ? 80 : undefined;



  const [activeMenu, setActiveMenu] = useState("my_profile");

  const handleMenuClick = (event, tabItem) => {
    isUserScrolling.current = true; // Indicate that a scroll is initiated by the user
    // Trigger the scroll regardless of whether the tab is already active
    const ref = sectionRefs[tabItem]?.current;
    if (ref) {
      ref.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      console.log("ref:", ref);
    }

    // Set the active tab
    setActiveMenu(tabItem);
    // Reset user scrolling state after scroll
    setTimeout(() => (isUserScrolling.current = false), 500);
  };
  // console.log("Professional Information123", professionalData);

  const handleProfileClick = (recommendation) => {
    setSelectedRecommendation(recommendation);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRecommendation(null); // Reset the selected recommendation
  };

  const { softSkills, profSkills, profTools } = professionalData;

  // Create refs for each section
  const myProfileRef = useRef(null);
  const educationRef = useRef(null);
  const certificateRef = useRef(null);
  const experienceRef = useRef(null);

  const isUserScrolling = useRef(false); // Tracks user interaction to prevent race conditions

  // Map menu values to refs for easier access
  const sectionRefs = {
    my_profile: myProfileRef,
    education: educationRef,
    certificate: certificateRef,
    experience: experienceRef,
  };

  // Define the debounced function outside of useEffect
  const debouncedHandleScroll = _.debounce(() => {
    if (isUserScrolling.current) return;

    const scrollPosition = window.scrollY + 136; // Account for sticky header height
    let newActiveTab = activeMenu;

    // Find the section closest to the scroll position
    for (const [tab, ref] of Object.entries(sectionRefs)) {
      if (ref.current) {
        const { offsetTop, offsetHeight } = ref.current;
        if (
          scrollPosition >= offsetTop &&
          scrollPosition < offsetTop + offsetHeight
        ) {
          newActiveTab = tab;
          break;
        }
      }
    }

    if (newActiveTab !== activeMenu) {
      setActiveMenu(newActiveTab);
    }
  }, 100); // Debounce time in milliseconds

  useEffect(() => {
    // Attach the debounced function
    window.addEventListener("scroll", debouncedHandleScroll);

    // Clean up the debounced function
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, [activeMenu]); // Ensure the effect runs only once by not re-creating debouncedHandleScroll

  useEffect(() => {
    const options = {
      root: null, // Observe relative to the viewport
      threshold: [0.15, 0.75], // Trigger when 15% and 75% of the section become visible
    };

    let activeTab = null;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const tab = entry.target.getAttribute('data-tab');

        // If 15% or more of the section is visible, activate its tab
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15 && tab !== activeTab) {
          console.log(`Switching to visible section: ${tab}`);
          setActiveMenu(tab);
          activeTab = tab; // Update the active tab
        }
      });
    }, options);

    // Observe each section
    Object.values(sectionRefs).forEach(ref => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      observer.disconnect(); // Clean up the observer when component unmounts
    };
  }, [sectionRefs]);

  const userFullName =
    professionalData.firstName + " " + professionalData.lastName;
  const sortedEducationList = sortListByDate(educationList, "education");
  const sortedCertificateList = sortListByDate(certificateList, "certificates");
  const sortedExperienceList = sortListByDate(experienceList, "experience");
  const sortedProjectList = sortListByDate(projectList, "projects");
  const sortedAwardsList = sortListByDate(awardsList, "awards");

  let mostRecentExp = { logo: "", title: "" };
  let mostRecentEdu = { logo: "", title: "" };

  if (sortedExperienceList.length > 0) {
    const topItem = sortedExperienceList[0];
    mostRecentExp = {
      logo: topItem.companylogo.data || "",
      title: topItem.companyName,
    };
  }

  if (sortedEducationList.length > 0) {
    const topItem = sortedEducationList[0];
    mostRecentEdu = {
      logo: topItem.instlogo.data || "",
      title: topItem.institute,
    };
  }

  return (
    <>
      <div>

        <div>

          <div
            className="my-profile-bg"
            style={{
              backgroundImage: `url(${professionalData.coverPic || bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* <div className="My-Profile-Scanner-image">
                        <a
                            href={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                            target="_blank"
                            rel="noopener noreferrer"

                        >
                        <div className="profile-qr-container flex-center">
                            <QrCodeProfile
                                className="container-gift-2"
                                value={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                                style={{ height: "70px", width: " 70px" }}
                            />
                        </div>
                        </a>
                    </div> */}

            <div className="My-Profile-imgOutline flex-center">
              {/* <img className="myprofilePhoto" src={profilePicturePersonal} alt="profile" /> */}
              <div>
                <Avatar
                  sx={{ bgcolor: "#F4F7FE", width: "10rem", height: "10rem" }}
                >
                  {professionalData.profilePic ? (
                    <img
                      src={professionalData.profilePic}
                      alt="profilepicture"
                      className="profile-pic-avatar"
                    />
                  ) : (
                    <>
                      <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                    </>
                  )}
                </Avatar>
              </div>

            </div>


            <div className="My-Profile-Scanner-image">
              {/* <a
                      href={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                      target="_blank"
                      rel="noopener noreferrer"
        
                    > */}
              <div className="profile-qr-container flex-center">
                <QrCodeProfile
                  className="container-gift-2"
                  qrCodeUrl={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${professionalData?.encryptedId}`}
                  size={qrCodeSize}
                  logo={mostRecentExp?.logo}
                />
              </div>
              {/* </a> */}
            </div>
          </div>





        </div>


        <div className="col sec-first second-part-of-Screen">
          <div className="my-profile-heading-container">
            <div className="my-profile-heading d-flex flex-column">
              <span className="my-profile-heading name">{userFullName}</span>
              <span className="subheading mb-0">
                {professionalData.headline ? professionalData.headline : "---"}
              </span>
            </div>

            <div className="recent-experience">
              {sortedExperienceList?.length !== 0 && (
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex">
                    <div className="recent-logo">
                      {mostRecentExp.logo ? (
                        <img
                          src={mostRecentExp.logo}
                          className="contain-image-100"
                          alt="logo"
                        />
                      ) : (
                        <WorkRoundedIcon />
                      )}
                    </div>
                  </div>
                  <div>{mostRecentExp.title}</div>
                </div>
              )}

              {sortedEducationList?.length !== 0 && (
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex">
                    <div className="recent-logo">
                      {mostRecentEdu.logo ? (
                        <img
                          src={mostRecentEdu.logo}
                          className="contain-image-100"
                          alt="logo"
                        />
                      ) : (
                        <SchoolRoundedIcon />
                      )}
                    </div>
                  </div>
                  <div>{mostRecentEdu.title}</div>
                </div>
              )}
            </div>
          </div>
          <div className="my-profile-heading-content mt-1">
            <div className="profile-meta-info ms-0">
              <GroupsIcon />{" "}
              <span className="color-blue">
                {connectionCount || 0} Connections
              </span>
            </div>

            <div className="me-3">
              <a
                href={`/portfolio?encryptedId=${encodeURIComponent(
                  professionalData.encryptedId
                )}&link=${professionalData.accessToken}`}
                target="_blank"
                rel="noreferrer"
                className="bold-blue-box"
              >
                <span>My Portfolio</span>
                {/* <PublicIcon className="ms-2 icon-color" /> */}
              </a>
            </div>

            {Object.keys(resumeData).length > 0 && (
              <div>
                <a
                  // href={resumeData.data}
                  // download={resumeData.name}
                  className="bold-blue-box pointer"
                  onClick={() => openDocumentViewer(resumeData)}
                >
                  <span>My Resume</span>
                  {/* <PublicIcon className="ms-2 icon-color" /> */}
                </a>
              </div>
            )}

            {Object.keys(videoResume).length > 0 && (
              <div>
                <a
                  // href={resumeData.data}
                  // download={resumeData.name}
                  className="bold-blue-box pointer ms-4"
                  onClick={() => openDocumentViewer(videoResume)}
                >
                  <span>My Video Resume</span>
                  {/* <PublicIcon className="ms-2 icon-color" /> */}
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="p-3 pt-1">
          <div className="menu sticky-profile-tabs">
            <Tabs
              value={activeMenu}
              onChange={(e, newValue) => handleMenuClick(e, newValue)}
              aria-label="Profile Tabs"
              variant="scrollable"
              scrollButtons="auto"
              className="custom-profile-tabs"
              selectionFollowsFocus
            >
              <Tab label="My Profile" value="my_profile" />
              <Tab label="Education" value="education" />
              <Tab label="Certificate" value="certificate" />
              <Tab label="Experience" value="experience" />
            </Tabs>
          </div>

          <div
            className="shared-profile-view"
            data-tab="my_profile"
            ref={myProfileRef}
          >
            {professionalData.aboutMe && isFieldVisible.aboutMe && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent mb-0">About Me</h2>
                </div>
                <div className="text-left m-0 p-0 line-break">
                  {professionalData.aboutMe}
                </div>
              </div>
            )}

            <div className="professional-page-section">
              <div className="form-display-title">
                <h2 className="headingforContent mb-0">
                  Professional Information
                </h2>
              </div>
              <div className="prof-profile-tab-item">
                {/* <div className="institute-logo-container flex-center">
                    {professionalData?.companyLogo ? (
                      <img
                        src={professionalData?.companyLogo}
                        alt="Institute"
                      />
                    ) : (
                      <img src={NotAvailable} alt="Not Available" />
                    )}
                  </div> */}
                <div className="profile-tab-item-details text-left">
                  {professionalData?.companyName &&
                    professionalData?.isFieldVisible?.companyName ? (
                    <div className="university-name">
                      {professionalData.companyName}
                    </div>
                  ) : null}

                  {professionalData?.companyWebsite &&
                    professionalData?.isFieldVisible?.companyAddress ? (
                    <div className="bordered-study-year2 design-lighter-text flex-center">
                      {professionalData.companyWebsite}
                    </div>
                  ) : null}

                  {/* Check if companyAddress is visible and has value */}
                  {professionalData?.companyAddress &&
                    professionalData?.isFieldVisible?.companyAddress && (
                      <div>{professionalData.companyAddress}</div>
                    )}

                  <div className="bordered-study-year2 design-lighter-text flex-center">
                    {professionalData?.startDate
                      ? formatDate(professionalData.startDate) + " - "
                      : ""}
                    {professionalData?.isCurrentlyWorking
                      ? "Present"
                      : professionalData?.endDate
                        ? formatDate(professionalData.endDate)
                        : ""}
                  </div>

                  {/* Display Designation and Department based on the logic provided */}
                  {professionalData?.isFieldVisible?.designation &&
                    professionalData?.designation &&
                    professionalData?.isFieldVisible?.department &&
                    professionalData?.department ? (
                    <div>
                      {professionalData.designation} -{" "}
                      {professionalData.department}
                    </div>
                  ) : professionalData?.isFieldVisible?.designation &&
                    professionalData?.designation ? (
                    <div>{professionalData.designation}</div>
                  ) : professionalData?.isFieldVisible?.department &&
                    professionalData?.department ? (
                    <div>{professionalData.department}</div>
                  ) : null}
                </div>
              </div>
            </div>

            {Object.keys(services).length > 0 && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent">Services</h2>
                </div>

                <div className="education-list">
                  <div className="education-item text-left profile-form-display">
                    <div>
                      <div className="project-profile">Services Provided:</div>
                      <div className="design-lighter-textNew">
                        {services.serviceList.map((service, index) => (
                          <span key={index}>
                            {service}{" "}
                            {index < services.serviceList.length - 1 && (
                              <span>&middot;</span>
                            )}{" "}
                          </span>
                        ))}
                      </div>
                    </div>
                    {services?.servicesDetails?.trim() !== "" && (
                      <div>
                        <div className="project-profile">Service Details:</div>
                        <div className="design-lighter-textNew line-break">
                          {services.servicesDetails}
                        </div>
                      </div>
                    )}
                    {(services?.workLocation !== "" ||
                      services.remote !== "") && (
                        <div>
                          <div className="project-profile">Work Location:</div>
                          <div className="design-lighter-textNew">
                            {services.workLocation} <span>&middot;</span>{" "}
                            {services.remote}
                          </div>
                        </div>
                      )}

                    <div>
                      {((services.dayStart && services.dayEnd) ||
                        (services.workStart && services.workEnd)) && (
                          <>
                            <div className="project-profile">Working Hours:</div>
                            <div className="design-lighter-textNew">
                              {services.dayStart && services.dayEnd && (
                                <>
                                  {services.dayStart} to {services.dayEnd}
                                  <span> &middot; </span>
                                </>
                              )}
                              {services.workStart && services.workEnd && (
                                <>
                                  {formatTimeAmPm(services.workStart)} to{" "}
                                  {formatTimeAmPm(services.workEnd)}
                                </>
                              )}
                            </div>
                          </>
                        )}
                    </div>

                    {services.hourRate > 0 && (
                      <div>
                        <div className="project-profile">Pricing:</div>
                        <div className="design-lighter-textNew me-2">
                          Starting at {services.currency} {services.hourRate}
                          /hour
                        </div>
                      </div>
                    )}

                    {services?.serviceAttachments?.length !== 0 && (
                      <div>
                        <div className="project-profile">Attachments:</div>
                        {services.serviceAttachments?.map((attachment, idx) => (
                          <div
                            key={idx}
                            className="profile-project-display mb-3"
                          >
                            {typeof attachment === "string" ? (
                              <div className="design-lighter-textNew">
                                {attachment}
                              </div>
                            ) : (
                              <div className="Documents-Attachments">
                                <PreviewFileItem file={attachment} fontColor="#00000099" />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {softSkills.skills.length > 0 && softSkills.isPublic && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent mb-0">Soft Skills</h2>
                </div>
                <div className="skills-list-professional">
                  {softSkills.skills?.map((skill, index) => (
                    <SkillItem key={index} label={skill} />
                  ))}
                </div>
              </div>
            )}
            {profSkills.skills.length > 0 && profSkills.isPublic && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent mb-0">
                    Professional Skills
                  </h2>
                </div>
                <div className="skills-list-professional">
                  {profSkills.skills?.map((skill, index) => (
                    <SkillItem key={index} label={skill} />
                  ))}
                </div>
              </div>
            )}

            {recommendations.length === 0 ? (
              <div></div> // Message for empty recommendations
            ) : (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent mb-0">Recommendations</h2>
                </div>

                <div
                  className="recommendations-list"
                  style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
                >
                  {recommendations.map((recommendation) => (
                    <div
                      key={recommendation.writerId}
                      className="recommendation-item"
                      onClick={() => handleProfileClick(recommendation)} // Click to open modal with details
                      style={{
                        cursor: "pointer",
                        display: "inline-block",
                        textAlign: "center",
                      }}
                    >
                      {recommendation?.profilePic ?
                        <img
                          src={
                            recommendation?.profilePic || "https://via.placeholder.com/50"
                          }
                          alt={recommendation.name}
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            marginBottom: "10px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}

                        /> :
                        <Avatar
                          sx={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            marginBottom: "10px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <InsertPhotoIcon sx={{ color: "white" }} fontSize="large" />
                        </Avatar>}
                      <div>{recommendation.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <Dialog
              open={openModal}
              onClose={handleCloseModal}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Recommendation Details</DialogTitle>
              <DialogContent>
                {selectedRecommendation && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {selectedRecommendation.profilePic ? <img
                        src={
                          selectedRecommendation.profilePic ||
                          "https://via.placeholder.com/80"
                        }
                        alt={selectedRecommendation.firstName}
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          marginRight: "20px",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        }}
                      /> :
                        <Avatar
                          sx={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            marginBottom: "10px",
                            marginRight: "20px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <InsertPhotoIcon sx={{ color: "white" }} fontSize="large" />
                        </Avatar>}

                      <div>
                        <h4>{`${selectedRecommendation.firstName} ${selectedRecommendation.lastName}`}</h4>
                        <p>{selectedRecommendation.text}</p>
                      </div>
                    </div>
                  </>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseModal} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            {profTools.skills.length > 0 && profTools.isPublic && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent mb-0">Tools</h2>
                </div>
                <div className="skills-list-professional">
                  {profTools.skills?.map((skill, index) => (
                    <SkillItem key={index} label={skill} />
                  ))}
                </div>
              </div>
            )}

            {sortedProjectList?.length > 0 && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent">Project Details</h2>
                </div>

                <div className="education-list">
                  {projectList?.map((project, index) => (
                    <div
                      key={index}
                      className="education-item text-left profile-form-display"
                    >
                      <div>
                        <div className="project-profile">Name:</div>
                        <div className="design-lighter-textNew">
                          {project.projectName}
                        </div>
                      </div>
                      {((project?.startMonth && project?.startYear) ||
                        (project?.endMonth && project?.endYear)) && (
                          <div>
                            <div className="project-profile">Duration:</div>
                            <div className="design-lighter-textNew">
                              {project.startMonth} {project.startYear} -{" "}
                              {project?.currentlyWorking
                                ? "Present"
                                : project.endMonth + " " + project.endYear}
                            </div>
                          </div>
                        )}
                      {project?.projectDescription?.length !== 0 && (
                        <div>
                          <div className="project-profile">Description:</div>
                          <div className="design-lighter-textNew me-2 line-break">
                            {project.projectDescription}
                          </div>
                        </div>
                      )}
                      {project?.attachments?.length !== 0 && (
                        <>
                          <div>
                            <div className="project-profile">Attachments:</div>
                            {project?.attachments?.map((attachment, idx) => (
                              <div
                                key={idx}
                                className="profile-project-display my-3"
                              >
                                {typeof attachment === "string" ? (
                                  <a href={attachment?.data}>
                                    <div className="design-lighter-textNew">
                                      {attachment}
                                    </div>
                                  </a>
                                ) : (
                                  <div className="Documents-Attachments">
                                    <PreviewFileItem file={attachment} fontColor="#00000099" />
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                      <div className="divider" />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {sortedAwardsList?.length > 0 && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent">Honors and Awards</h2>
                </div>

                <div className="education-list">
                  {awardsList?.map((award, index) => (
                    <div
                      key={index}
                      className="education-item text-left profile-form-display"
                    >
                      <div>
                        <div className="project-profile">Title:</div>
                        <div className="design-lighter-textNew">
                          {award.awardTitle}
                        </div>
                      </div>
                      {(award?.issueMonth || award?.issueYear) && (
                        <div>
                          <div className="project-profile">Issue Date:</div>
                          <div className="design-lighter-textNew">
                            {award.issueMonth} {award.issueYear}
                          </div>
                        </div>
                      )}
                      {award?.associatedWith && (
                        <div>
                          <div className="project-profile">
                            Associated With:
                          </div>
                          <div className="design-lighter-textNew">
                            {award.associatedWith}
                          </div>
                        </div>
                      )}
                      {award?.awardIssuer && (
                        <div>
                          <div className="project-profile">Issuer:</div>
                          <div className="design-lighter-textNew">
                            {award.awardIssuer}
                          </div>
                        </div>
                      )}
                      {award?.awardDescription?.length !== 0 && (
                        <div>
                          <div className="project-profile">Description:</div>
                          <div className="design-lighter-textNew me-2 line-break">
                            {award.awardDescription}{" "}
                          </div>
                        </div>
                      )}

                      {award?.awardAttachments?.length !== 0 && (
                        <div>
                          <div className="project-profile">Attachments:</div>

                          {award?.awardAttachments
                            ?.filter((attachment) => !attachment.toBeDeleted)
                            ?.map((attachment, idx) => (
                              <div
                                key={idx}
                                className="profile-project-display my-3"
                              >
                                {typeof attachment === "string" ? (
                                  <a href={attachment}>
                                    <div className="design-lighter-textNew">
                                      {attachment}
                                    </div>
                                  </a>
                                ) : (
                                  <div className="Documents-Attachments">
                                    <PreviewFileItem file={attachment} fontColor="#00000099" />
                                  </div>
                                )}
                              </div>
                            ))}
                        </div>
                      )}
                      <div className="divider" />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div
            className="shared-profile-view"
            data-tab="education"
            ref={educationRef}
          >
            <div className="professional-page-section">
              <div className="form-display-title">
                <h2 className="headingforContent">Education</h2>
              </div>

              <div className="education-list">
                {sortedEducationList?.map((education, index) => (
                  <div className="education-item" key={index}>
                    <div className="prof-profile-tab-item">
                      <div className="institute-logo-container flex-center">
                        {education?.instlogo?.data ? (
                          <img src={education.instlogo?.data} alt="Institute" />
                        ) : (
                          <img src={NotAvailable} alt="Not Available" />
                        )}
                      </div>
                      <div className="institute-details d-flex flex-column text-left">
                        <div className="d-flex justify-content-between mb-0">
                          <div className="university-name">
                            <span>{education.institute}</span>
                            <span className="span-center-align">
                              {education.isVerified === true ? (
                                <VerifiedTick className="green-verified-tick" />
                              ) : (
                                <VerifiedTick />
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="bordered-study-year2 design-lighter-text flex-center">
                          {education.startYear} - {education.endYear}
                        </div>
                        {education.degree ? (
                          <div className="mb-1">{education.degree}</div>
                        ) : null}
                        {education.fieldofStudy ? (
                          <div className="mb-1">{education.fieldofStudy}</div>
                        ) : null}
                        {education.eduLevel === "SSLC" ? (
                          <div className="mb-1">{education.eduLevel}</div>
                        ) : null}
                        <div className="mb-1">{education.universityName}</div>
                        {education?.description !== "" && (
                          <>
                            <div className="mb-1">Details:</div>
                            <div className="design-lighter-text margin-bottom-8px word-break line-break">
                              {education.description}
                            </div>
                          </>
                        )}
                        {education?.certificatepic?.data && (
                          <div
                            className="d-flex align-items-center flex-start pointer"
                            onClick={() =>
                              openDocumentViewer(education.certificatepic)
                            }
                          >
                            <div className="Certificate-design me-2">
                              View Certificate
                            </div>
                            <IoLinkSharp className="icon-color" />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="divider" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className="shared-profile-view"
            data-tab="certificate"
            ref={certificateRef}
          >
            <div className="professional-page-section">
              <div className="form-display-title">
                <h2 className="headingforContent">Certificates</h2>
              </div>

              <div className="education-list">
                {sortedCertificateList?.map((certification, index) => (
                  <div className="education-item" key={index}>
                    <div className="prof-profile-tab-item">
                      <div className="institute-logo-container mt-1 flex-center">
                        {certification?.certificateLogo?.data ? (
                          <>
                            <img
                              src={certification.certificateLogo?.data}
                              alt="Certificate Logo"
                            />
                          </>
                        ) : (
                          <img src={NotAvailable} alt="Not Available" />
                        )}
                      </div>
                      <div className="institute-details d-flex flex-column text-left">
                        <div className="d-flex justify-content-between mb-0">
                          <div className="university-name">
                            {certification.organName}
                            <span className="span-center-align">
                              {certification.isVerified === true ? (
                                <VerifiedTick className="green-verified-tick" />
                              ) : (
                                <VerifiedTick />
                              )}
                            </span>
                          </div>
                        </div>
                        {(certification.certifiMonth ||
                          certification.certifiYear) && (
                            <div className="bordered-study-year2 design-lighter-text flex-center">
                              {certification.certifiMonth}{" "}
                              {certification.certifiYear}
                            </div>
                          )}
                        <div className="mb-1">{certification.courseName}</div>
                        {certification?.certifiDetails && (
                          <>
                            <div className="mb-1">Details:</div>
                            <div className="design-lighter-text margin-bottom-8px word-break line-break">
                              {certification.certifiDetails}
                            </div>
                          </>
                        )}
                        {certification?.certificatePDF?.data && (
                          <div
                            className="d-flex align-items-center flex-start pointer"
                            onClick={() =>
                              openDocumentViewer(certification.certificatePDF)
                            }
                          >
                            <div className="Certificate-design me-2">
                              View Certificate
                            </div>
                            <IoLinkSharp className="icon-color" />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="divider" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className="shared-profile-view"
            data-tab="experience"
            ref={experienceRef}
          >
            <div className="professional-page-section">
              <div className="form-display-title">
                <h2 className="headingforContent">Experience</h2>
              </div>

              <div className="education-list">
                {sortedExperienceList?.map((experience, index) => (
                  <div className="education-item" key={index}>
                    <div className="prof-profile-tab-item">
                      <div className="institute-logo-container mt-1 flex-center">
                        {experience.companylogo?.data ? (
                          <img
                            src={experience.companylogo?.data}
                            alt={experience.companylogo?.name}
                          />
                        ) : (
                          <img src={NotAvailable} alt="Not Available" />
                        )}
                      </div>
                      <div className="institute-details experience-info d-flex flex-column text-left">
                        <div className="d-flex justify-content-between mb-0">
                          <div className="university-name">
                            {experience.companyName}
                            <span className="span-center-align">
                              {experience.isVerified === true ? (
                                <VerifiedTick className="green-verified-tick" />
                              ) : (
                                <VerifiedTick />
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-start design-lighter-text">
                          <div>{experience.location}</div>
                          <span className="dot-locationtype">.</span>
                          <div>{experience.locationType}</div>
                        </div>
                        <div className="bordered-study-year2 design-lighter-text flex-center mb-2">
                          {experience.startMonth.substring(0, 3).toUpperCase()}{" "}
                          {experience.startYear} -{" "}
                          {experience.endYear === "Present"
                            ? "Present"
                            : `${experience.endMonth
                              .substring(0, 3)
                              .toUpperCase()} ${experience.endYear}`}
                        </div>
                        <div className="role-title-bold">
                          {experience.roleTitle}
                        </div>
                        <div className="">{experience.employmentType}</div>
                        <div className="design-lighter-text">
                          {experience.responsibility?.map(
                            (responsibility, index, array) => (
                              <span key={index}>
                                {responsibility}
                                {index !== array.length - 1 && " • "}
                              </span>
                            )
                          )}
                        </div>
                        {experience.details && (
                          <>
                            <div className="mb-1">Details:</div>
                            <div className="design-lighter-text margin-bottom-8px word-break line-break">
                              {experience.details}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="divider" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfessionalProfileView;
